import { startG3Telemetry } from './g3-telemetry/index.js';

const g3 = startG3Telemetry({
  ingestUrl: G3_INGEST_URL,
  reportToken: G3_REPORT_TOKEN,
  commit: G3_COMMIT_SHA,
  deployUrl: G3_DEPLOY_URL,
});

import { render } from 'preact';
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/600.css';
import '@fontsource/barlow-semi-condensed/600.css';
import '@fontsource/barlow-semi-condensed/700.css';
import './styles.css';
import { App } from './app.jsx';

window.__g3 = g3;
render(<App />, document.getElementById('app'));

// a module worker: it imports the outbox chunk it shares with the app
if ('serviceWorker' in navigator) navigator.serviceWorker.register('/sw.js', { type: 'module' }).catch(() => {});
